import { Col, Container, Row, TextInput } from 'react-materialize';
import Modal from './modal';
import React from 'react';

import AddressForm from "../../address/AddressForm";

class ModalFaq extends React.Component {

  state = {
  estado: '',
  municipio: '',
  codigo_postal: '',
  colonias: []
};

  async componentDidMount() {
  }

  handleCloseModal = () => {
    this.props.onClose();
  };

  handleAddressChange = (data) => {

    if (!data) {

      this.setState({
        estado: '',
        municipio: '',
        codigo_postal: '',
        colonias: []
      });
      return;
    }

    this.setState({
      estado: data.estado,
      municipio: data.municipio,
      codigo_postal: data.codigo_postal,
      colonias: data.colonias
    });
    console.log('Prueba state ', this.state);

  };
  
  render() {
    let image1 = `${this.props.url}FAQ/ERROR1.png`;
    let image2 = `${this.props.url}FAQ/ERROR2-1.png`;
    let image3 = `${this.props.url}FAQ/ERROR3.png`;
    let image4 = `${this.props.url}FAQ/ERROR4.png`;
    let image5 = `${this.props.url}FAQ/ERROR5.png`;
    let image6 = `${this.props.url}FAQ/ERROR6.png`;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.isOpen}
          onClose={this.handleCloseModal}
        >
          <Container>
            <Row>
              <Col>
                <AddressForm  onChange={this.handleAddressChange} ></AddressForm>
                <TextInput
                  id="stateCustomerReadonly"
                  s={12}
                  value={this.state.estado}
                  label="Estado"
                  disabled
                />
               
              </Col>
              <Col>
                <h3 className="m3">PREGUNTAS FRECUENTES</h3>
                <img src={image1} alt=""/>
                <p style={{color:'blue', fontSize:'30px'}}>
                  NO CARGAN ARTICULOS, CLIENTES, IMAGENES, COLORES.                     
                </p>
                <p style={{color:'red', fontSize:'30px'}}>
                   ACCION: ACTUALIZAR PAGINA O SALIR Y ENTRARA AL PV
                </p>
                    <img src={image2} alt="" />
                    <p style={{color:'blue', fontSize:'30px'}}>
                      USUARIO Y PASSWORD INCORRECTOS .                     
                    </p>
                  <p style={{color:'red', fontSize:'30px'}}>
                    ACCION: VERIFICAR QUE LA RUTA SEA "HTTP" Y NO "HTTPS"
                     EJEMPLO: http://pos.miplayera.com.mx/#</p>
                     <img src={image3} alt=""/>
                    <p style={{color:'blue', fontSize:'30px'}}>
                      ERROR AL DAR DE ALTA A UN CLIENTE .                     
                    </p>
                  <p style={{color:'red', fontSize:'30px'}}>
                    ACCION: ACTUALIZAR PAGINA O SALIR Y ENTRARA AL PV
                    </p>
                  <img src={image4} alt=""/>
                    <p style={{color:'blue', fontSize:'30px'}}>
                      ERROR AL CANCELAR PEDIDOS.                     
                    </p>
                  <p style={{color:'red', fontSize:'30px'}}>
                      ACCION: NO TIENE LOS PERMISOS, NO TIENE REMISION O YA ESTA FACTURADO</p>
                      <img src={image5}alt="" />
                      <p style={{color:'blue', fontSize:'30px'}}>
                        ERROR AL CREAR REMISION.                     
                      </p>
                    <p style={{color:'red', fontSize:'30px'}}>
                      ACCION: VERIFICAR LA EXISTENCIA DE LOS PRODUCTOS CON ALMACEN
                      YA QUE NO SE CREA REMISION POR INV. INSUFICIENTE (INVENTARIO INSUFICIENTE)
                    </p>
                      <img src={image6} alt=""/>
                      <p style={{color:'blue', fontSize:'30px'}}>
                        NO SE RECIBE RESPUESTA DEL SERVIDOR                      
                      </p>
                    <p style={{color:'red', fontSize:'30px'}}>
                      ACCION: REINICIAR, DE PERSISTIR EL ERROR REPORTAR AL AREA DE SISTEMAS
                    </p>
              </Col>
            </Row>
          </Container>
        </Modal>
      </React.Fragment>
    );
  }

}
export { ModalFaq as default };
